import React, { useState, useEffect, useRef } from "react";

import { 
  Campaign, 
  Quest,
} from "@dndModels";

import DandDAPI from "@utilities/smart_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CharConnectUtilities from "@dndUtilities/char_connect_utilities";
import { makeStyles } from "@utilities/theme_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import FlexBox from "@components/layout/FlexBox";
import StringBox from "@components/input/strings/StringBox";
import QuestCard from "./QuestCard";

interface Props {
  campaign: Campaign;
  quest: Quest;
  onChange: () => void;
  onDelete: () => void;
}

const api = DandDAPI.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const connect_util = CharConnectUtilities.getInstance();

export default function QuestInput({ campaign, quest, onChange, onDelete }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  const [ping, setPing] = useState(false);
  const [open, setOpen] = useState(quest.title.length === 0);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={open}
        full_page
        onClose={() => { setOpen(false); }}>
        <QuestCard
          campaign={campaign}
          quest={quest}
          enabled
          index={0}
          onChange={onChange}
        />
      </ModalOrDrawer>
    )
  }

  return (
    <div className="padded">
      <FlexBox direction="column" className={cx(classes.root)}>
        <FlexBox direction="row">
          <FlexBox className="header padded clickable" onClick={() => {
            setOpen(true); 
          }}>{ quest.title }</FlexBox>
          <FlexBox xs_expand={0}>
            <div style={{ float: "right"}}>
              <DeleteButton
                no_fab
                obj_name={quest.title}
                onClick={onDelete}
              />
            </div>
          </FlexBox>
        </FlexBox>
      </FlexBox>
      { renderExtras() }
    </div>
  );
}
